import React, { useState } from "react";
import { useVSU } from "../store";
import { PALETTE } from "../constants";
import { fmtShare } from "../helpers";
import EmptyState from "./EmptyState";

const CX = 115,
  CY = 115,
  R = 108;

function point(angle) {
  return [CX + R * Math.sin(angle), CY - R * Math.cos(angle)];
}
function slicePath(start, end) {
  const [x1, y1] = point(start);
  const [x2, y2] = point(end);
  const large = end - start > Math.PI ? 1 : 0;
  return (
    `M ${CX} ${CY} L ${x1.toFixed(3)} ${y1.toFixed(3)} ` +
    `A ${R} ${R} 0 ${large} 1 ${x2.toFixed(3)} ${y2.toFixed(3)} Z`
  );
}

export default function PieChartCard({ title, field, data }) {
  const { t, lang, toggleBreakdownFilter } = useVSU();
  const [hover, setHover] = useState(null); // { index, x, y }

  if (!data || data.length === 0) {
    return (
      <div className="vsu-pie-card">
        <div className="vsu-pie-title">{title}</div>
        <EmptyState title={t("emptyT")} desc={t("emptyD")} />
      </div>
    );
  }

  const total = data.reduce((s, d) => s + d.count, 0);
  const label = (d) => (d ? (lang === "kk" ? d.value_kk : d.value_ru) : "");
  const color = (i) => PALETTE[i % PALETTE.length];

  const single = data.length === 1;

  let acc = 0;
  const slices = data.map((d, i) => {
    const start = (acc / total) * 2 * Math.PI;
    acc += d.count;
    const end = (acc / total) * 2 * Math.PI;
    return { d, i, start, end };
  });

  const onSelect = (d) => toggleBreakdownFilter(field, d.value_ru);

  const hovered = hover && data[hover.index] ? data[hover.index] : null;

  return (
    <div className="vsu-pie-card">
      <div className="vsu-pie-title">{title}</div>

      <div className="vsu-pie-wrap" onMouseLeave={() => setHover(null)}>
        <svg
          viewBox="0 0 230 230"
          className="vsu-pie-svg"
          role="img"
          aria-label={title}
        >
          {single ? (
            <circle
              cx={CX}
              cy={CY}
              r={R}
              fill={color(0)}
              stroke="#1e2532"
              strokeWidth="2"
              className="vsu-slice"
              onClick={() => onSelect(data[0])}
              onMouseMove={(e) =>
                setHover({
                  index: 0,
                  x: e.nativeEvent.offsetX,
                  y: e.nativeEvent.offsetY,
                })
              }
            />
          ) : (
            slices.map(({ d, i, start, end }) => (
              <path
                key={i}
                d={slicePath(start, end)}
                fill={color(i)}
                stroke="#1e2532"
                strokeWidth="2"
                className="vsu-slice"
                onClick={() => onSelect(d)}
                onMouseMove={(e) =>
                  setHover({
                    index: i,
                    x: e.nativeEvent.offsetX,
                    y: e.nativeEvent.offsetY,
                  })
                }
              />
            ))
          )}
        </svg>

        {hovered && (
          <div
            className="vsu-tooltip"
            style={{ left: hover.x + 12, top: hover.y + 12 }}
          >
            <div className="vsu-tt-name">{label(hovered)}</div>
            <div className="vsu-tt-val">
              {hovered.count} {t("unitsShort")} · {fmtShare(hovered.share_pct)}%
            </div>
          </div>
        )}
      </div>

      <div className="vsu-pie-legend">
        {data.map((d, i) => (
          <div
            key={d.value_ru}
            className="vsu-pl-row"
            onClick={() => onSelect(d)}
            title={label(d)}
          >
            <span className="vsu-pl-sw" style={{ background: color(i) }} />
            <span className="vsu-pl-nm">{label(d)}</span>
            <span className="vsu-pl-vl">
              {d.count} {t("unitsShort")} · {fmtShare(d.share_pct)}%
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
